export default class FeatherIcons {
  constructor() {
    this.setup();
  }
  setup() {
    window.feather = require('feather-icons');
    feather.replace();
  }
}
